<template>
    <div>
        <Modal
            v-model="showModal"
            draggable
            sticky
            :title="title"
            width="600"
            no-footer
            :closable="closable"
            class="createRequest"
            :before-close="handleReset"
        >
            <Form
                ref="form"
                :model="form"
                :rules="isDisabled ? ruleInline : ruleInlineWithCreatedAt"
                :loading="isLoading"
                label-position="left"
                class="create-time-dispute-wrapper"
            >
                <Row>
                    <Col span="8">
                        <FormItem label="Coe Type">
                            <Select
                                v-model="form.type"
                                style="width: 200px"
                                :value="form.type"
                                :disabled="forEdit && !enableForUpdate"
                            >
                                <Option v-for="item in coeType" :key="item.value" :value="item.value">{{
                                    item.name
                                }}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="8">
                        <FormItem label="Reason for request (optional)">
                            <Input
                                v-model="form.reason"
                                type="textarea"
                                :disabled="forEdit && !enableForUpdate"
                                :autosize="{ minRows: 2, maxRows: 5 }"
                                placeholder="Enter something..."
                                style="width: 400px"
                            />
                        </FormItem>
                    </Col>
                </Row>
                <Row v-if="forEdit && ['pending', 'approved'].includes(form.status) && userType === 'admin'">
                    <Col span="8">
                        <FormItem label="COE File:">
                            <Upload action="//jsonplaceholder.typicode.com/posts/" :before-upload="testUpload">
                                <Button icon="ios-cloud-upload-outline">Upload files</Button>
                            </Upload>
                            <div v-if="file !== null">
                                Upload file: {{ file.name }}
                                <Button type="text" :loading="isLoading" @click="deleteFile">x</Button>
                            </div>
                            <div v-if="form.path !== null">
                                Upload file: {{ form.path }}
                                <Button type="text" :loading="isLoading" @click="deleteFile">x</Button>
                            </div>
                            <Button
                                v-if="forEdit && form.status === 'approved' && userType === 'admin'"
                                class="pt-btn-3"
                                :loading="isLoading"
                                :disabled="file == null"
                                @click="handleApprove"
                            >
                                Reupload
                            </Button>
                        </FormItem>
                    </Col>
                    <Col span="8"> </Col>
                </Row>
                <FormItem v-if="form.status" label="Status">
                    <div :class="getStatusClass(form.status)">{{ form.status }}</div>
                </FormItem>
                <Row v-if="form.status === 'approved'">
                    <Col span="8">
                        <FormItem label="File">
                            <Button
                                v-if="form.status === 'approved' && userType === 'employee'"
                                class="pt-btn-3"
                                :loading="isLoading"
                                @click="downloadCoeEmployee"
                            >
                                Download
                            </Button>
                            <Button
                                v-if="form.status === 'approved' && userType === 'admin'"
                                class="pt-btn-3"
                                :loading="isLoading"
                                @click="downloadCoeAdmin"
                            >
                                Download
                            </Button>
                        </FormItem>
                    </Col>
                </Row>
                <Row v-if="form.status === 'approved'">
                    <Col span="8">
                        <FormItem label="Pin">
                            {{ form.pin }}
                        </FormItem>
                    </Col>
                </Row>
            </Form>
            <div>
                <Button class="pt-btn-2" style="margin-right: 10px" @click="handleCancel"> CANCEL </Button>
                <Button v-if="!forEdit && !enableForUpdate" class="pt-btn-3" :loading="isLoading" @click="handleSubmit">
                    SUBMIT
                </Button>
                <Button v-if="enableForUpdate" class="pt-btn-3" :loading="isLoading" @click="handleUpdate">
                    UPDATE
                </Button>
                <Button
                    v-if="forEdit && form.status === 'pending' && userType === 'admin'"
                    class="pt-btn-3"
                    :loading="isLoading"
                    :disabled="file == null"
                    @click="handleApprove"
                >
                    Approve
                </Button>
            </div>
        </Modal>
    </div>
</template>
<script>
import moment from 'moment';
import { timeConversion } from '../../../../../utility/helper';
import { getRequestRecordByUserAndAttendanceId } from '@/services/requests.services';
import { getPaginatedAttendanceRecords } from '@/services/attendancelogs.services';
import {
    approveCoe,
    postCoe,
    getCoeDetailsAdmin,
    getPrivateCoeUrl,
    updateCoe,
    getPrivateCoeUrlAdmin,
    retrieveEmployeePasswordCoe,
    getCoeDetailsEmployee,
} from '@/services/coe.services';

export default {
    data() {
        const validateCreatedAt = (rule, value, callback) => {
            console.log('validate:', value, rule);
            const date = value;
            if ((date && date == '  ') || !date) {
                return callback(new Error('Please fill in date'));
            } else {
                getPaginatedAttendanceRecords(
                    this.userId,
                    {
                        ...{
                            clockInTime: {
                                $gte: timeConversion(date, '00:00'),
                                $lte: timeConversion(date, '23:59'),
                            },
                        },
                    },
                    this.currentPage,
                    15
                )
                    .then((res) => {
                        if (res.data.data.length > 0) {
                            getRequestRecordByUserAndAttendanceId(this.attendanceLogData._id, this.userId, {
                                requestedStart: timeConversion(moment(date).format('DD-MMM-YYYY'), '00:00'),
                            })
                                .then((result) => {
                                    if (result.data.length > 0) {
                                        return callback(
                                            new Error('You already have a request in progress with this date')
                                        );
                                    } else {
                                        return callback();
                                    }
                                })
                                .catch(() => {
                                    return callback(new Error('Please fill in date'));
                                });
                        } else {
                            return callback(new Error('You have no attendance record with this date'));
                        }
                    })
                    .catch(() => {
                        return callback(new Error('Please fill in date'));
                    });
            }
        };
        return {
            title: 'Create CoE Request',
            attendanceLogData: null,
            isLoading: false,
            options: null,
            closable: false,
            enableForUpdate: false,
            form: {
                createdAt: null,
                type: null,
                reason: '',
            },
            coeType: [
                { name: 'Without Income', value: 'Without-Income' },
                { name: 'With Income', value: 'With-Income' },
            ],
            file: null,
            forEdit: false,
            ruleInline: {
                requestedStartTime: [
                    {
                        required: true,
                        message: 'Please fill in start time',
                        trigger: 'change',
                    },
                ],
                requestedEndTime: [
                    {
                        required: true,
                        message: 'Please fill in end time',
                        trigger: 'change',
                    },
                ],
            },
            ruleInlineWithCreatedAt: {
                createdAt: [
                    {
                        validator: validateCreatedAt,
                        trigger: 'change',
                    },
                ],
                requestedStartTime: [
                    {
                        required: true,
                        message: 'Please fill in start time',
                        trigger: 'change',
                    },
                ],
                requestedEndTime: [
                    {
                        required: true,
                        message: 'Please fill in end time',
                        trigger: 'change',
                    },
                ],
            },
            userType: null,
            isDisabled: false,
            showModal: false,
            userId: null,
        };
    },
    created() {
        this.options = {
            disabledDate(date) {
                const isCurrentDate = date && moment(date).format('DD-MMM-YYYY') == moment().format('DD-MMM-YYYY');
                return isCurrentDate ? false : date && date.valueOf() > Date.now() - 86400000;
            },
        };
    },
    methods: {
        getStatusClass(status) {
            const data = {
                pending: 'warning',
                rejected: 'danger',
                approved: 'success',
                cancelled: 'danger',
            };
            return `statusLabel ${data[status]}`;
        },
        async handleSubmit() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.submitCoe();
                } else {
                    this.$Message.error('Fill in the required fields');
                }
            });
        },
        async handleUpdate() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.submitUpdateCoe();
                } else {
                    this.$Message.error('Fill in the required fields');
                }
            });
        },
        testUpload(file) {
            console.log('file test upload: ', file);
            this.file = file;
        },

        submitCoe() {
            this.isLoading = true;

            const data = {
                type: this.form.type,
                reason: this.form.reason,
            };
            postCoe(data)
                .then(() => {
                    this.$Message.success('Request COE submitted');
                    this.isLoading = false;
                    this.$emit('create');
                    this.showModal = false;
                    this.$refs.form.resetFields();
                })
                .catch((err) => {
                    console.log('err: ', err);
                    this.$Message.error('Failed to submit CoE Request. Please select coe Type and fill up reason');
                    this.isLoading = false;
                });
        },

        submitUpdateCoe() {
            this.isLoading = true;

            const data = {
                type: this.form.type,
                reason: this.form.reason,
                id: this.form.id,
            };
            updateCoe(data)
                .then(() => {
                    this.$Message.success('Request COE updated');
                    this.isLoading = false;
                    this.$emit('create');
                    this.showModal = false;
                    this.$refs.form.resetFields();
                })
                .catch((err) => {
                    console.log('err: ', err);
                    this.$Message.error('Failed to submit CoE Request. Please select coe Type and fill up reason');
                    this.isLoading = false;
                });
        },

        handleApprove() {
            this.isLoading = true;

            const data = {
                file: this.file,
                id: this.form.id,
            };
            approveCoe(data)
                .then(({ data }) => {
                    this.$Message.success('Request COE approved');
                    this.isLoading = false;
                    this.$emit('create');
                    // this.showModal = false;
                    this.file = null;
                    console.log('data: ', data);
                    this.form.pin = data.data.password;
                    this.form.path = data.data.path;

                    this.$refs.form.resetFields();
                })
                .catch((err) => {
                    console.error('failed to approve', err);
                    this.$Message.error('failed to approve');
                    this.isLoading = false;
                });
        },

        openModal() {
            this.isLoading = false;
            this.showModal = true;
            this.forEdit = false;
            this.form = { createdAt: null, type: null, reason: '', pin: null };
        },
        openModalForEditing(coe) {
            this.isLoading = false;
            this.showModal = true;
            this.enableForUpdate = true;
            this.form.type = coe.requestedData.type;
            this.form.status = coe.status;
            this.form.reason = coe.requestedData.reason;
            this.form.pin = null;
            this.form.id = coe._id;
        },
        openModalForUpdating(coe) {
            this.isLoading = false;
            this.showModal = true;
            this.forEdit = true;
            this.form.type = coe.requestedData.type;
            this.form.status = coe.status;
            this.form.reason = coe.requestedData.reason;
            this.form.pin = null;
            this.form.id = coe._id;
        },

        async openModalForAdmin(coe) {
            console.log('coe: ', coe);
            const { data } = await getCoeDetailsAdmin(coe);
            this.isLoading = false;
            this.userType = 'admin';
            this.showModal = true;
            this.forEdit = true;
            this.title = 'Coe Request Details';
            this.form.type = data.requestedData.type;
            this.form.reason = data.requestedData.reason;
            this.form.path = data.requestedData.path;
            this.form.pin = null;
            this.form.status = data.status;
            this.form.id = data._id;
        },

        async openModalForEmployee(data) {
            const { data: coe } = await getCoeDetailsEmployee(data._id);
            this.isLoading = false;
            this.showModal = true;
            this.forEdit = true;
            this.title = 'Coe Request Details';
            this.form.type = coe.requestedData.type;
            this.form.reason = coe.requestedData.reason;
            this.form.path = coe.requestedData.path;
            this.userType = 'employee';
            this.form.pin = null;
            this.form.status = coe.status;
            this.form.id = coe._id;
        },

        async downloadCoeAdmin() {
            console.log('downloading coe', this.form);
            this.isLoading = true;
            const {
                data: { url },
            } = await getPrivateCoeUrlAdmin(this.form.id);
            const {
                data: { requests },
            } = await retrieveEmployeePasswordCoe(this.form.id);
            this.form.pin = requests;
            this.$nextTick(() => {
                window.open(url, '_blank').focus();
                this.isLoading = false;
            });
        },
        async downloadCoeEmployee() {
            console.log('downloading coe');
            this.isLoading = true;
            const {
                data: { requests },
            } = await retrieveEmployeePasswordCoe(this.form.id);
            const {
                data: { url },
            } = await getPrivateCoeUrl(this.form.id);
            this.form.pin = requests;
            this.$nextTick(() => {
                window.open(url, '_blank').focus();
                this.isLoading = false;
            });
        },
        async retrievePassword() {
            this.isLoading = true;
            const {
                data: { requests },
            } = await retrieveEmployeePasswordCoe(this.form.id);
            this.form.pin = requests;
            this.$nextTick(() => {
                this.isLoading = false;
            });
        },

        handleCancel() {
            this.isLoading = false;
            this.showModal = false;
            this.$refs.form.resetFields();
        },

        handleConfirm() {
            this.showModal = false;
        },

        handleReset() {
            this.$refs.form.resetFields();
        },
    },
};
</script>
<style lang="scss">
form.ivu-form.ivu-form-label-left.ivu-form-inline {
    border: unset;
    .ivu-form-item {
        display: inline-block !important;
        margin-right: 10px !important;
        vertical-align: top !important;
    }

    .ivu-form-item-content {
        margin-left: 0 !important;
        display: block !important;
    }
}
.createRequest .ivu-modal-body {
    padding: 16px;
}
.createRequest .ivu-modal-footer {
    display: none;
}
.createRequest .ivu-spin-main {
    justify-content: center;
    display: flex;
}
.create-time-dispute-wrapper {
    .ivu-form-item {
        display: inline-block !important;
        margin-right: 10px !important;
        vertical-align: top !important;
    }

    .ivu-form-item-content {
        margin-left: 0 !important;
        display: block !important;
    }
}

@media screen and (max-width: 767px) {
    .create-time-dispute-wrapper {
        .ivu-form-item {
            margin: 20px 5px;

            .ivu-form-item-content {
                margin-left: 0 !important;
                display: block !important;
            }
        }
    }
}
</style>
